import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/system/admin_list',
    ADD: '/system/admin_add',
    UPDATE: '/system/admin_update',
    SET_DISABLED: '/system/admin_set_disabled',
    RESET_PASSWORD: '/system/admin_reset_password',
    IS_EXIST_ACCOUNT: '/system/admin_is_exist_account',
    IS_EXIST_TEL: '/system/admin_is_exist_tel',
    IS_EXIST_MAIL: '/system/admin_is_exist_mail',
	
	BIND_GOOGLE_AUTH: '/system/admin_bind_google_auth',
	BIND_GOOGLE_AUTH_PRO: '/system/admin_bind_google_auth_pro',
	UNBIND_GOOGLE_AUTH: '/system/admin_unbind_google_auth',
}

export async function adminList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function adminAdd(form) {
    return requestPost(api.ADD, form);
}

export async function adminUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function adminResetPassword(form) {
    return requestPost(api.RESET_PASSWORD, form);
}

export async function adminSetDisabled(id, disabled) {
    let params = {
        id: id,
        disabled: disabled
    };
    return requestPost(api.SET_DISABLED, params);
}

export async function adminAccountIsExist(account) {
    let params = {val: account};
    return requestGet(api.IS_EXIST_ACCOUNT, params);
}

export async function adminTelIsExist(tel) {
    let params = {val: tel};
    return requestGet(api.IS_EXIST_TEL, params);
}

export async function adminMailIsExist(mail) {
    let params = {val: mail};
    return requestGet(api.IS_EXIST_MAIL, params);
}

export async function adminBindGoogleAuth(id) {
	let params = {
		id: id
	};
	return requestGet(api.BIND_GOOGLE_AUTH, params);
}

export async function adminBindGoogleAuthPro(params) {
	return requestPost(api.BIND_GOOGLE_AUTH_PRO, params);
}

export async function adminUnBindGoogleAuth(id) {
	let params = {
		id: id
	};
	return requestPost(api.UNBIND_GOOGLE_AUTH, params);
}